import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: { xs: '8px', xl: '16px' },
    padding: '20px 24px',
  },
  contentGrid: {
    display: 'grid',
    rowGap: '32px',
    columnGap: '80px',
    gridTemplateColumns: 'repeat(3,1fr)',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
};
